import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const f = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 75 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M74.375 20C74.375 9.3 65.701.625 55 .625 44.3.625 35.625 9.299 35.625 20c0 10.7 8.675 19.375 19.375 19.375S74.375 30.701 74.375 20",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M73.75 20c0 10.355-8.395 18.75-18.75 18.75S36.25 30.355 36.25 20 44.645 1.25 55 1.25 73.75 9.645 73.75 20M48.337 37.336c5.219-7.417 7.013-13.903 7.023-18.214.011-4.31-2.353-7.303-5.358-7.928-.596-.124-1.22-.26-1.773-.231-.554.028-2.229.037-3.306-.418-1.688-.714-2.868-2.162-2.644-3.923a.24.24 0 0 1 .317-.194c5.728 1.895 14.836 5.008 25.315 3.19.166-.028.316.106.285.27-.236 1.258-1.251 2.27-2.356 2.27-1.2 0-3.788-.986-5.21-.34-1.147.523-2.679 3.268-2.05 6.861 1.123 6.413 4.59 4.922 6.788 2.45-.824 4.12-2.198 7.417-7.692 6.593-.824 2.472-1.841 6.043-9.34 9.614m10.439-30.97c1.068-1.349 1.276-2.964.464-3.607s-2.337-.072-3.405 1.276S54.559 7 55.37 7.642s2.337.072 3.405-1.277",
      fill: "#3120DF"
    }
  ),
  /* @__PURE__ */ l.jsx("path", { d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20", fill: "#8F8FEF" }),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "m20.41 3.167-.024.04L24.55 24.5l10.337 3.75zm-.937.666L5 28.917h.012l16.53-14.479zM34.97 29.208l-20.46-7.416-8.499 7.416z",
      fill: "#fff"
    }
  )
] });
export {
  f as G
};
